<template>
  <div>
    <div class="text-center">
      <h1>Brand</h1>
    </div>
    <div v-if="isAdmin" class="d-flex justify-content-end mx-5">
      <button
        @click="() => $router.push({ name: 'DetailBrand' })"
        class="btn btn-outline-primary"
      >
        Create
      </button>
    </div>
    <div class="text-center px-3">
      <ListBrands />
    </div>
  </div>
</template>

<script>
import ListBrands from "./ListBrands.vue";
import { TokenService } from "services/storage.service";

export default {
  data() {
    return {
      isAdmin: false,
    };
  },
  components: {
    ListBrands,
  },
  mounted() {
    this.isAdminRole();
  },
  methods: {
    isAdminRole() {
      const userRole = JSON.parse(TokenService.getUserRoles());
      this.isAdmin = userRole.find((u) => u === "ROLE_ADMIN");
    },
  },
};
</script>
